import { useEffect, useState } from 'react';

// Returns true when viewport width is <= breakpoint (default 768px).
// Used to swap dense tables for stacked list rows on mobile, while keeping
// the same data and the same actions — not a card layout, just adaptive.
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
